module.exports = __webpack_public_path__ + "img/inpatient.22e32a13.jpeg";